module.exports = __webpack_public_path__ + "img/rhdsp.8587ddf7.svg";